import React from 'react';
import { BaseModal } from 'components/modals/BaseModal';
import styled from 'styled-components';

interface IProps {
  title?: string;
  onClose: () => void;
  children: React.ReactNode;
}

export const CreateFlowModal = (props: IProps) => {
  const { title, onClose, children } = props;

  return (
    <FixedWidthModalWrapper>
      <BaseModal title={title} onClose={onClose}>
        {children}
      </BaseModal>
    </FixedWidthModalWrapper>
  );
};

const FixedWidthModalWrapper = styled.div`
  > div > div {
    width: 800px !important;
    max-width: 90vw;
  }
`;